export default __webpack_public_path__ + "static/media/instoremusic1.803bf641.jpg";